// extracted by mini-css-extract-plugin
export var labelWrapper = "_fn-0";